import * as React from "react"
import type { SVGProps } from "react"
const SvgTiktokLogo = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={20}
    height={20}
    viewBox="0 0 256 256"
    {...props}
  >
    <path
      fill="currentColor"
      strokeMiterlimit={10}
      d="M48 8H16a8 8 0 0 0-8 8v32a8 8 0 0 0 8 8h32a8 8 0 0 0 8-8V16a8 8 0 0 0-8-8m2 19c-3.964 0-6.885-1.09-9-2.695V38.5C41 44.841 35.841 50 29.5 50S18 44.841 18 38.5 23.159 27 29.5 27h2v5h-2a6.51 6.51 0 0 0-6.5 6.5c0 3.584 2.916 6.5 6.5 6.5s6.5-2.916 6.5-6.5V14h5c.018 1.323.533 8 9 8z"
      fontFamily="none"
      fontSize="none"
      fontWeight="none"
      style={{
        mixBlendMode: "normal",
      }}
      textAnchor="none"
      transform="matrix(5 0 0 5 -32 -32)"
    />
  </svg>
)
export default SvgTiktokLogo
